/**
 * Software Secure Crypto Robustness.
 *
 * @group DRM
 *
 * @beta
 */
export const SW_SECURE_CRYPTO = 'SW_SECURE_CRYPTO';
